import { formatNumber } from "@angular/common";

export class TimeUtil {

    public static getHoursText(hours: number, dp: number = 0) {
        if(!hours) return '0h'; //None';

        var hr = Math.trunc(hours);

        var mins = (hours % 1) * 60;

        var mn = dp == 0 ? Math.round(mins) : +mins.toFixed(dp);

        return (hr > 0 ? `${hr}h` : '') + (mn > 0 ? ` ${mn}m` : '');
    }

    public static getWeeksText(hours: number) {
        if(!hours) return '0 weeks';

        var weeks = hours / 35;
        var wks = Math.trunc(weeks);
        var days  = (weeks % 1) * 5;
        var dys = Math.trunc(days);
        var hrs = Math.round((days % 1) * 7);

        return (wks > 0 ? `${wks} weeks` : '') + (dys > 0 ? ` ${dys} days` : '') + (hrs > 0 ? ` ${hrs} hrs` : '');
    }

    public static getWeeksNumber(hours: number) {
        if(!hours) return "0";

        return (hours / 35).toFixed(1);
    }

    public static getHoursTextMinimal(hours: number) {
        if(!hours) return '0h';

        var hr = Math.trunc(hours);
        var mn = Math.round((hours % 1) * 60);

        return (hr > 0 ? `${formatNumber(hours, "en-US", "1.0-2")}h ` : `${mn}m`);
    }

    public static getHoursFromHoursText(text: string) {
        if(!text.includes('h') && !text.includes('m')) {
            const dregex = /(\d+(.\d+)?)/g;
            const dfound = text.match(dregex);
            return dfound?.length ? dfound[0] : '0';
        }

        const hregex = /(\d+(.\d+)?)h/g;
        const hfound = text.match(hregex);
        var hours = hfound?.length ? hfound[0] : '0';

        const mregex = /(\d+)m/g;
        const mfound = text.match(mregex);
        var mins = mfound?.length ? mfound[0] : '0';

        if(!hfound && !mfound) return '0';

        return (Number.parseFloat(hours) + Number.parseInt(mins) / 60).toFixed(2);
    }

    public static getDaysIntervalText(startDate: Date, endDate: Date, includeMins = true): string {
        const diffMs = endDate.getTime() - startDate.getTime();
        
        const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
        
        if (days > 0) {
            return `${days}d${hours > 0 ? ` ${hours}h` : ''}${includeMins && minutes > 0 ? ` ${minutes}m` : ''}`;
        } else if (hours > 0) {
            return `${hours}h${includeMins ? ` ${minutes}m` : ''}`;
        } else {
            return `${minutes}m`;
        }
    }

    public static getDaysBetween(date1: Date, date2: Date) {
        return Math.floor((Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate()) - Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate()) ) / (1000 * 60 * 60 * 24));
    }

    public static getHoursBetween(date1: Date, date2: Date) {
        return Math.floor((date2.getTime() - date1.getTime() ) / (1000 * 60 * 60));
    }

    public static getMonthsBetween(date1: Date, date2: Date) {
        var total1 = date1.getFullYear() * 12 + date1.getMonth();
        var total2 = date2.getFullYear() * 12 + date2.getMonth();
        return Math.floor(total2 - total1);
    }

    public static addHours(date: Date, hours: number): Date {
        date.setTime(date.getTime() + (hours*60*60*1000));
        return date;
    }

    public static addSeconds(date: Date, seconds: number): Date {
        date.setTime(date.getTime() + (seconds*1000));
        return date;
    }

    public static setTo1amUTC(date: Date) {
        if(date.getHours() == 0)
            TimeUtil.addHours(date, 1);
        date.setHours(2);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);
        return date;
    }

    public static setTo2359UTC(date: Date) {
        TimeUtil.setTo1amUTC(date);
        date.setHours(23, 59);
        return date;
    }

    public static setTo1stOfMonth(date: Date) {
        TimeUtil.setTo1amUTC(date);
        date.setDate(1);
        return date;
    }

    public static setToEndOfMonth(date: Date) {
        TimeUtil.setTo1stOfMonth(date);
        TimeUtil.addMonths(date, 1);
        TimeUtil.addDays(date, -1);
        TimeUtil.setTo2359UTC(date);
        return date;
    }

    public static setToStartOfWeek(date: Date) {
        TimeUtil.setTo1amUTC(date);
        TimeUtil.addDays(date, date.getDay() * -1 + 1);
        return date;
    }

    public static setToEndOfWeek(date: Date) {
        TimeUtil.setToStartOfWeek(date);
        TimeUtil.addDays(date, 6);
        TimeUtil.setTo2359UTC(date);
        return date;
    }
    
    public static addDays(date: Date, days: number) {
        date.setTime(date.getTime() + (days*24*60*60*1000));
        return date;
    }

    public static addMonths(date: Date, months: number) {
        var previousMonth = date.getMonth();
        var newMonth = previousMonth + months;
        var newYear = newMonth >= 12 ? date.getFullYear() + 1 : date.getFullYear();

        var newDate = new Date(newYear, newMonth % 12, date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
        date.setTime(newDate.getTime());
        return date;
    }
    
    public static addYears(date: Date, years: number) {
        var newDate = new Date(date.getFullYear() + years, date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
        date.setTime(newDate.getTime());
        return date;
    }

    public static getEndOfCurrentYear() {
        var yearStart = TimeUtil.getStartOfCurrentYear();
        return TimeUtil.addHours(TimeUtil.addYears(yearStart, 1), -1/60/60);
    }

    public static getStartOfCurrentYear() {
        var now = new Date();
        return new Date(now.getFullYear(), 0, 1, 0, 0, 0);
    }

    public static getDaysOverlap(from1: Date, to1: Date, from2: Date, to2: Date) {
        if(from1 >= from2 && to1 <= to2)
            return TimeUtil.getDaysBetween(from1, to1);

        var start = Math.max(from1.getTime(), from2.getTime());
        var end = Math.min(to1.getTime(), to2.getTime());

        var days = end - start;

        return Math.round(days / (60*60*24*1000));
    }

    public static getDaysOverlapInCurrentYear(from: Date, to: Date) {
        return this.getDaysOverlap(from, to, TimeUtil.getStartOfCurrentYear(), TimeUtil.getStartOfCurrentYear());
        
        if(from >= TimeUtil.getStartOfCurrentYear() && to <= TimeUtil.getEndOfCurrentYear())
            return TimeUtil.getDaysBetween(from, to);

        var start = Math.max(from.getTime(), TimeUtil.getStartOfCurrentYear().getTime());
        var end = Math.min(to.getTime(), TimeUtil.getEndOfCurrentYear().getTime());

        var days = end - start;

        return Math.round(days / (60*60*24*1000));
    }

    public static getBiggestDate(date1: Date, date2: Date) {
        return date1 > date2 ? date1 : date2;
    }

    public static getSmallestDate(date1: Date, date2: Date) {
        return date1 < date2 ? date1 : date2;
    }
    
    public static getNowUTC() {
        const now = new Date();
        return new Date(now.getTime() + (now.getTimezoneOffset() * 60000));
    }

}
